// Quick replies for the support-chat composer: saved answers inserted with a click or typed as "/shortcut".
// Pure functions — the page decides when to call them.
export const PLACEHOLDERS = [
  { token: "{name}", label: "customer's first name" },
  { token: "{email}", label: "customer's email" },
  { token: "{brand}", label: "brand name" },
];
export function firstName(user = {}) {
  const name = String(user.name || "").trim();
  if (name) return name.split(/\s+/)[0];
  const email = String(user.email || "").trim();
  if (email.includes("@")) return email.split("@")[0];
  return "there";
}
export function fillQuickReply(body, { user = {}, brandName = "ProxyWarehouse" } = {}) {
  const values = { name: firstName(user), email: String(user.email || "").trim(), brand: String(brandName || "").trim() };
  return String(body || "").replace(/\{(name|email|brand)\}/gi, (match, key) => values[key.toLowerCase()] || match);
}
// "/" alone, "/fi", "/fixed" → the query without the slash; a sentence that starts with "/" is not a shortcut.
export function shortcutQuery(draft) {
  const match = /^\/([a-z0-9_-]*)$/i.exec(String(draft || ""));
  return match ? match[1].toLowerCase() : null;
}
export function filterQuickReplies(replies = [], query = "") {
  const needle = String(query || "").trim().toLowerCase().replace(/^\/+/, "");
  if (!needle) return [...replies];
  return replies.map((reply) => {
    const shortcut = String(reply.shortcut || "").toLowerCase(), title = String(reply.title || "").toLowerCase(), body = String(reply.body || "").toLowerCase();
    let score = 0;
    if (shortcut && shortcut === needle) score = 4; else if (shortcut && shortcut.startsWith(needle)) score = 3; else if (title.includes(needle)) score = 2; else if (body.includes(needle)) score = 1;
    return { reply, score };
  }).filter((x) => x.score > 0).sort((a, b) => b.score - a.score).map((x) => x.reply);
}
// An empty draft (or one that is just the "/shortcut" being typed) is replaced; anything else gets the reply appended.
export function insertQuickReply(draft, text) {
  const current = String(draft || "");
  if (!current.trim() || shortcutQuery(current) !== null) return text;
  return `${current}${current.endsWith("\n") ? "" : "\n"}${text}`;
}
